<template>
  <div class="authenticAtionPending">
        <div class="title">
            实名认证检测中
        </div>
        <div class="logo">
           <!-- 旋转的圆圈 -->
            <div class="custom-loading-circle"></div>
            <img class="logo-img" src="@/assets/style/idCardLoading-bg.png" alt="">
        </div>
        <div class="tip">
            你的身份信息已提交，请耐心等待
        </div>
  </div>
</template>

<script>
export default {
  name: "authenticAtionPending",
  components: {},
  props: {
    
  },
  data() {
    return {
    };
  },
  async mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.authenticAtionPending {
  height: 480px;
}
.title{
    text-align: center;
    font-size: 18px;
    color: #333333;
    padding-top: 68px;
    margin-bottom: 20px;
}
.tip{
    text-align: center;
    font-size: 14px;
    color: #777777;
    padding-top: 30px;
}
.logo{
    text-align: center;
    position: relative;
    height: 230px;
    display: flex;
    align-items: center;
    justify-content: center;
    .logo-img{
     width: 140px;
      height: 140px;
    }
    .logo-img1{
      width: 210px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
}
.custom-loading-circle {
  width: 210px;
  height: 210px;
  border: 10px solid #e5e5e5;      /* 灰色浅底边框 */
  border-top-color: #F24334;   /* 亮蓝色高亮边框（滚动条颜色） */
  border-radius: 50%;          /* 变成完美的圆形 */
  animation: loading-spin 0.8s linear infinite; /* 匀速、无限循环旋转 */
  position: absolute;
}
/* 旋转动画定义 */
@keyframes loading-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
